<template>
    <div class="card card-register">
      <div class="card__body">
        <div class="logo">
          <nuxt-link :to="isApplicationRegister ? '/lp/create' : '/'">
            <img v-if="isApplicationRegister" class="lp" src="/img/lp-create/create-logo.svg">
            <img v-else src="/frontend/img/logo-c.svg">
          </nuxt-link>
        </div>
        <div class="card_form_content center-form">
          <div class="form">
            <h1 v-if="isApplicationRegister"  class="auth__heading">LegalScript書類作成へようこそ</h1>
            <h1 v-else class="auth__heading">モチカケにようこそ</h1>
            <h4 class="mb16">登録するメールアドレスを入力してください</h4>
            <validation-observer v-slot="{ handleSubmit }" ref="observer">
              <form @submit.prevent="handleSubmit(handleRegister)">
                <div class="auth__register__section mail_register_form">
                  <div class="group-register-input">
                    <validation-provider name="メールアドレス" rules="required|email|max:128" v-slot="{errors}">
                      <input type="text" class="input__text" name="メールアドレス" id="email" placeholder="legalscript@example.com" v-model="formData.email" :class="errors[0] || (formErrors['email'] && formErrors['email'][0]) ? 'is-invalid' : 'mb16'">
                      <invalid-feedback class="mb16" :errors="errors" />
                    </validation-provider>
                  </div>
                </div>
                <div slot="footer" class="mt48">
                  <p v-if="isApplicationRegister" class="auth__register__text mb20 auth__links">
                    <nuxt-link target="_blank" to="/terms-application">利用規約</nuxt-link>と<nuxt-link target="_blank" to="/privacy-application">プライバシーポリシー</nuxt-link>に同意して
                  </p>
                  <p v-else class="auth__register__text mb20 auth__links">
                    <nuxt-link target="_blank" to="/terms">利用規約</nuxt-link>と<nuxt-link target="_blank" to="/privacy">プライバシーポリシー</nuxt-link>に同意して
                  </p>
                  <div>
                    <button type="submit" class="button button--block button--primary mb20 button--register-app" :disabled="btnLoading">
                      <BSpinner v-if="btnLoading" class="mr-1"/>
                      無料でアカウント登録する
                    </button>
                  </div>
                  <div class="auth__links auth__register__link">
                    <nuxt-link v-if="isApplicationRegister" :to="{ path: '/auth/login-application', query: $route.query }">ログインはこちら</nuxt-link>
                    <nuxt-link v-else to="/auth/login">ログインはこちら</nuxt-link>
                  </div>
                </div>
              </form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import companyMixin from "@/mixins/companyMixin";
  import registerMixin from "@/mixins/registerMixin";
  import InvalidFeedback from '@/components/particles/InvalidFeedback';
  import BSpinner from '@/components/particles/BSpinner';

  export default {
    components: { InvalidFeedback, BSpinner},
    mixins: [companyMixin, registerMixin],
    props: {
        isApplicationRegister: {
            type: Boolean,
            default: false,
        },
        registerLandingId: {
          type: Number,
          default: null
        },
        registerApplicationId: {
          type: Number,
          default: null
        }
    },
    data: (app) => ({
      retype_password: '',
      formData: {
        email: app.$store.state.frontend.auth.registerEmail,
        register_media: process.client ? sessionStorage.getItem('rf') : null,
      }
    }),
  }
  </script>

  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

